import React, { useState } from "react";
import { Row, Col, Tooltip, Drawer, Button } from "antd";
import DrawDetail from "./drawerDetail";
import { isMobile } from "@/utils/public";

function Detail(props) {
  const { data, style, mobile = false, changTab } = props;
  console.log(data, "模型广场数据");
  const [open, setOpen] = useState(false);
  const [id, setId] = useState("");
  const [title, setTitle] = useState("");
  const isMob = isMobile();
  return (
    <>
      <Row gutter={[16, 16]} className="zdCardDetail" style={style}>
        {data?.map((item) => {
          return (
            <Col
              className="znt-col"
              xs={{ span: 24 }}
              md={{ span: 12 }}
              lg={{ span: 8 }}
              style={{ cursor: "pointer" }}
            >
              <div className="detailItem">
                <div className="topTitle">
                  <div className="img">
                    <img src={item.icon} alt=" " />
                  </div>
                  <div className="con">
                    <div className="label">
                      <Tooltip title={item.label}>
                        <div className="la">{item.label}</div>
                      </Tooltip>
                    </div>
                    <span className="tag">{item.tag}</span>
                  </div>
                  <div
                    className="apply"
                    onClick={() => {
                      // changTab();
                      window.open("https://dev.zju.edu.cn/")
                    }}
                  >
                    申请使用
                  </div>
                </div>
                <div className="description">
                  <Tooltip title={item.des}>
                    <div className="des">{item.des}</div>
                  </Tooltip>
                </div>
                <div className="bottomContent">
                  <div className="sj">{item.sj}</div>
                  <div className="actions">
                    <span
                      className="edit"
                      onClick={() => {
                        setOpen(true);
                        setId(item.key);
                        setTitle(item.label);
                      }}
                    >
                      API调用说明
                    </span>
                    <span className="line"></span>
                    <span className="edit"></span>
                  </div>
                </div>
              </div>
            </Col>
          );
        })}
      </Row>
      <Drawer
        title={title}
        open={open}
        destroyOnHidden
        onClose={() => {
          setOpen(false);
          setId("");
          setTitle("");
        }}
        width={isMob ? "100%" : "40%"}
        footer={
          <>
            <Button
              onClick={() => {
                setOpen(false);
                setId("");
                setTitle("");
              }}
            >
              关闭
            </Button>
          </>
        }
      >
        <DrawDetail id={id} />
      </Drawer>
    </>
  );
}

export default Detail;
